












































































import { Component, Prop, Mixins, Watch } from "vue-property-decorator";
import { CreateElement } from "vue";
import _ from "@/boot/lodash";

// Mixins
import Context from "@/mixins/context";
import VaultInjectorMixin from "@/mixins/vaultInjectorMixin";

// Enums/Data
import { ClientRoutes } from "@/data/enums/router";
import { DataModules } from "@/store/modules/data";

// Types
import { IVaultAsset } from "@/models/vaultAssets";
import { IContractProduct } from "@/models/contracts";
import { IRoute } from "@/models/routes";

@Component({
  components: {
    "vault-asset-dropdown-control": () =>
      import("@/components/app/global/vault/vaultAssetDropdownControl.vue")
  }
})
export default class VaultSecretItem extends Mixins(
  Context,
  VaultInjectorMixin
) {
  // Props

  @Prop({ default: false })
  public isLoading!: boolean;

  @Prop({ default: null })
  public asset!: IVaultAsset;

  @Prop({ default: null })
  public contractProductId!: IContractProduct["id"];

  @Prop({ default: false })
  public isDisabled!: boolean;

  // Data

  public isDecrypting = false;
  public isDecrypted = _.isNull(this.asset) ? false : !this.asset.encrypted;
  public note: IVaultAsset["note"] = _.isNull(this.asset)
    ? ""
    : this.asset.encrypted
    ? "•".repeat(12)
    : this.asset.note;
  public clientRoutes = ClientRoutes;
  public isUpdating = false;

  // Methods

  public toggleVisibility() {
    if (this.isDecrypted) {
      this.isDecrypted = false;
      this.note = this.asset.note;
      return;
    }
    this.decryptVaultAsset();
  }

  public async decryptVaultAsset() {
    if (!this.vaultData.canDecrypt) return;
    this.isDecrypting = true;
    try {
      const { note } = await this.$vaultMethods.decryptVaultAsset(
        this.asset.id
      );
      this.note = note;
      this.isDecrypted = true;
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
    } finally {
      this.isDecrypting = false;
    }
  }

  public async togglePin() {
    if (!this.vaultData.canUpdate || this.isDisabled) return;

    this.isUpdating = true;

    try {
      await this.$vaultMethods.updateVaultAsset(this.asset.id, {
        pinned: !this.asset.pinned
      });
      this.$store.dispatch("toast/show", {
        message: this.$t("_sentence.vault.secret_updated")
      });
      await this.$vaultMethods.refreshData();
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
    } finally {
      this.isUpdating = false;
    }
  }

  // Computed

  public get showSkeletons() {
    return this.$_.isNull(this.asset);
  }

  public get randomBulls() {
    return `&bull;`.repeat(this.$_.random(8, 16));
  }

  public get visibilityControl() {
    return {
      render: (h: CreateElement) => {
        return h("b-button", {
          class: [this.isDecrypted ? "has-text-dark" : "has-text-success"],
          props: {
            iconLeft: this.isDecrypted ? "eye-slash" : "lock",
            loading: this.isDecrypting,
            type: "is-white"
          },
          on: {
            click: () => {
              if (this.isDisabled) return;
              this.toggleVisibility();
            }
          }
        });
      }
    };
  }

  public get isHiddenFromClient() {
    return !(this.asset?.visible_for_client ?? true);
  }

  public get cProd() {
    return this.asset?.contract_product;
  }

  public get cProdName() {
    return this.$store.getters[`data/${DataModules.CONTRACTS_PRODUCTS}/name`](
      this.cProd
    );
  }

  public get cProdRoute() {
    return this.$store.getters[`data/${DataModules.CONTRACTS_PRODUCTS}/route`]({
      ...this.cProd,
      client_id: this.asset?.client_id
    })?.to as IRoute["to"];
  }

  // Watchers

  @Watch("asset.note")
  public onAssetNoteChange() {
    this.isDecrypted = false;
    this.note = this.asset.note;
  }
}
